<template>
    <div class="w-full">
        <div class="text-left mx-8 mt-4 mb-4">
            <input id="declaration-check" v-model="noEmployment" type="checkbox" name="noEmployment" @click="noEmployment = !noEmployment" />
            <label for="no-employment" class="ml-2 text-right"><strong>No previous employment</strong></label>
        </div>
        <div v-if="successMessage" class="mx-8 mb-4 success-message">{{ successMessage }}</div>
        <div v-if="!noEmployment">
            <div>
                <p class="text-left mx-8 mt-4">
                    Please provide details of your employment, most recent first.
                </p>
            </div>
            <div class="w-full text-left pl-8 pt-4">* Required fields</div>
            <div class="p-4">
                <div v-for="(record, index) in employment" :key="record" class="w-full">
                    <div>
                        <employment-details-form
                            :employment-data="record"
                            :application-reference="applicationReference"
                            :item-index="index"
                            :countries-of-domicile-list="countriesOfDomicileList"
                            @delete="removeOne"
                        />
                    </div>
                </div>
            </div>

            <div v-if="employmentCount < 5">
                <button class="btn-green mb-8" @click="newEmployment">Add <span v-if="employmentCount > 0">other</span> employment record</button>
            </div>
        </div>
        <div v-else class="text-left ml-8 relative">
            <button class="btn-green mb-8 w-40" @click="noPriorEmployment">Save</button>
            <div v-if="loading" class="lds-ring-container absolute top-2 left-2">
                <div class="lds-ring"><div /><div /><div /><div /></div>
            </div>
        </div>
    </div>
</template>

<script>

import EmploymentDetailsForm from '@/views/Application/Details/EmploymentDetailsForm'

export default {
    components: {
        EmploymentDetailsForm,
    },
    props: {
        employmentData: Object,
        applicationReference: String,
        countriesOfDomicileList: Object,
        applicationData: Object,
    },
    data() {
        return {
            employment: Object,
            formDirty: false,
            loading: false,
            successMessage: '',
            serverErrors: '',
            addEmployment: false,
            noEmployment: this.applicationData.data.no_prior_employment === 1 ? true : false,
        }
    },
    computed: {
        employmentCount() {
            return this.employment.length + ((this.addEmployment === true)? 1: 0)
        },
    },
    mounted() {
        this.employment = this.employmentData

        if (this.employment.length === 0)
        {
            this.newEmployment()
        }
    },
    methods: {
        removeOne(index) {
            this.employment.splice(index, 1)
        },
        newEmployment() {
            this.employment.push({
                reference: null,
                start_date: null,
                end_date: null,
                country_id: null,
                institution_name: null,
                online_distance_learning: null,
                qualification_type: null,
                subject: null,
                final_result: null,
                tuition_language: null,
            })
        },
        noPriorEmployment() {
          this.loading = true
          this.$store.dispatch('noPriorEmployment', {
            applicationReference: this.applicationReference,
          }).then(response => {
            this.loading = false
            this.successMessage = response.data
          })
              .catch(error => {
                this.loading = false
                this.successMessage = ''
              })
        },
    },
}
</script>